import { createFileRoute } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { useQuery } from "@tanstack/react-query";
import { Loader2, Bell } from "lucide-react";
import { listMyNotifications } from "@/lib/portal/portal.functions";

export const Route = createFileRoute("/_authenticated/portal/notifications")({
  component: NotificationsPage,
});

function NotificationsPage() {
  const fn = useServerFn(listMyNotifications);
  const { data, isLoading } = useQuery({ queryKey: ["portal", "notifications"], queryFn: () => fn() });

  return (
    <div className="space-y-6">
      <header>
        <p className="text-amber-300 text-[11px] tracking-[0.3em] uppercase font-semibold">Notifications</p>
        <h1 className="font-serif text-4xl text-white mt-1">Activity</h1>
      </header>
      {isLoading ? (
        <div className="py-20 grid place-items-center"><Loader2 className="size-6 animate-spin text-amber-300" /></div>
      ) : !data || data.length === 0 ? (
        <div className="rounded-3xl border border-white/10 bg-white/[0.02] p-12 text-center">
          <Bell className="size-8 text-zinc-400 mx-auto mb-3" />
          <p className="text-zinc-400">You're all caught up.</p>
          <p className="text-zinc-400 text-xs mt-1">Updates from your project team will appear here.</p>
        </div>
      ) : (
        <ul className="space-y-2">
          {data.map((n) => (
            <li key={n.id} className={`rounded-2xl border p-4 ${n.read_at ? "border-white/10 bg-white/[0.02]" : "border-amber-300/30 bg-amber-300/[0.04]"}`}>
              <div className="flex items-start justify-between gap-3">
                <div>
                  <p className="text-white text-sm font-medium">{n.title}</p>
                  {n.body && <p className="text-zinc-400 text-sm mt-1">{n.body}</p>}
                </div>
                <span className="text-[10px] text-zinc-500 shrink-0">{new Date(n.created_at).toLocaleString()}</span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}